module.exports = __webpack_public_path__ + "img/lamination.f4b9e95c.png";